import {createContext, useContext} from 'react';
import type {AiChatContextType} from '@/ai-chat/providers/ai-chat-provider.types';

export const aiChatContext = createContext<AiChatContextType | undefined>(undefined);

export function useAiChat(): AiChatContextType {
  const context: AiChatContextType | undefined = useContext(aiChatContext);

  if (context === undefined) {
    throw new Error('useAiChat must be used within an AiChatProvider');
  }

  return context;
}

